
import {
  defineComponent, PropType, ref, SetupContext, watch, toRaw,
} from 'vue';
import { Checkbox, Empty, Spin } from 'ant-design-vue';
import Draggable from 'vuedraggable';
import { cloneDeep, uniqueId } from 'lodash';
import { IProps, IColumns, IBaseRecord } from "./lib/index";

export default defineComponent({
  components: {
    Draggable,
    aCheckbox: Checkbox,
    aEmpty: Empty,
    aSpin: Spin,
  },
  emits: ['select-change', 'end'],
  props: {
    /** 表格数据  v-model:dataSource */
    dataSource: {
      type: Array as PropType<Array<IBaseRecord>>,
      default() {
        return [];
      },
    },
    /** 表格列 */
    columns: {
      type: Array as PropType<Array<IColumns>>,
      default: () => [],
    },
    /** 表格loading状态 */
    loading: {
      type: Boolean,
      default: false,
    },
    /** bordered */
    bordered: {
      type: Boolean,
      default: true,
    },
    /** 复选框 */
    rowSelect: {
      type: Boolean,
      default: true,
    },
    /** 根据 rowSelectKey 返回选中值 ——noYet 暂时没想到怎么用，会抱错 */
    rowSelectKey: {
      type: String,
      default: 'id',
    },
    /** table-head-style */
    tHeadStyle: {
      type: Object,
      default: () => ({}),
    },
    /** option 🔗https://github.com/SortableJS/Sortable#options */
    /** table 🔗https://github.com/SortableJS/vue.draggable.next/blob/master/example/components/table-example.vue */
    /** vue3-table的调用方式发生了变化 */
    dragOption: {
      type: Object,
      default: () => ({
        disabled: false,
        draggable: '.dt-item',
        animation: 150,
        handle: '.td-handle',
      }),
    },
  },
  setup(props: IProps, ctx: SetupContext) {
    /** model-data */
    const dragData = ref<IBaseRecord[]>([]);
    const isAllCheck = ref(false);

    /** 根据rowKey获得选中ids */
    const getSelectKeys = () => dragData.value.filter((v: IBaseRecord) => v.isChecked).map((v: IBaseRecord) => v.id);

    const checkAll = () => {
      dragData.value.forEach((d: IBaseRecord) => {
        d.isChecked = isAllCheck.value;
      });
      ctx.emit('select-change', { selectRowKeys: getSelectKeys() });
    };
    const checkChange = () => {
      isAllCheck.value = dragData.value.every((d: IBaseRecord) => d.isChecked);
      ctx.emit('select-change', { selectRowKeys: getSelectKeys() });
    };

    /** 拖拽结束 */
    const onDragEnd = () => {
      console.log(props.loading);
      const newList = cloneDeep(toRaw(dragData.value)).map((d: IBaseRecord, i: number) => ({ ...d, seq: i }));
      ctx.emit('end', newList);
    };

    watch(() => props.dataSource, async (newV) => {
      if (newV) {
        dragData.value = (cloneDeep(toRaw(props.dataSource)) as IBaseRecord[]).map((d: IBaseRecord) => ({ ...d, uid: uniqueId(''), isChecked: false }));
      }
    }, { immediate: true, deep: true });
    return {
      dragData,
      // checked
      isAllCheck,
      checkAll,
      checkChange,
      // emit
      onDragEnd,
      // empty
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
    };
  },
});
